<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <h5>Depot Discount Group: {{discountGroup.name}}</h5>
                <h5>Depot: {{discountGroup.depot}}</h5>
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="row" v-if="!showSuccessMessage && !showErrorMessage">
                    <div class="col-6">
                        <div class="card border border-secondary">
                            <div class="card-body text-secondary">
                                <h5 class="card-title text-secondary">Assigned</h5>
                                <data-table
                                        :headings="customerDiscountGroupHeadings"
                                        :data="customerDiscountGroupCustomers"
                                        :hasActions="true"
                                        :hasCustomActionComponent="true"
                                        :stateChanged="assignFilterStateChanged"
                                        :pagingDetails="pagingDetails"
                                        @filterSearchClicked="onFilterAssignedSearchClicked">
                                    <template #filter>
                                        <div class="p-3">
                                            <div class="input-group pb-4">
                                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="assignedFilter.customerSearchQuery">
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon1">
                                                        <i class="fas fa-search"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <active-inactive-radio-buttons :activeInactiveKey="assignedFilter.activeOrInactiveItems"
                                                                           :componentId="'assignedCustomerFilterRadioButtons'"
                                                                           @activeInactiveSelected="onAssignedActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </template>
                                    <template #actionComponent="{ companyId }">
                                        <button class="btn btn-link" @click="unassignCustomerFromSalesRep(companyId)"
                                                :disabled="assignFilterStateChanged">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </template>
                                </data-table>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card border border-secondary">
                            <div class="card-body text-secondary">
                                <h5 class="card-title text-secondary">Unassigned</h5>
                                <data-table
                                        :headings="customerDiscountGroupHeadings"
                                        :data="unassignedCustomers"
                                        :hasActions="true"
                                        :hasCustomActionComponent="true"
                                        :stateChanged="unassignedFilterStateChanged"
                                        :pagingDetails="pagingDetails"
                                        @filterSearchClicked="onFilterUnassignedSearchClicked">
                                    <template #filter>
                                        <div class="p-3">
                                            <div class="input-group pb-4">
                                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="unassignedFilter.customerSearchQuery">
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon1">
                                                        <i class="fas fa-search"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <active-inactive-radio-buttons :activeInactiveKey="unassignedFilter.activeOrInactiveItems"
                                                                           :componentId="'unassignedCustomerFilterRadioButtons'"
                                                                           @activeInactiveSelected="onUnassignedActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </template>
                                    <template #actionComponent="{ companyId }">
                                        <button class="btn btn-link" @click="assignCustomerFromSalesRep(companyId)"
                                                :disabled="unassignedFilterStateChanged">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </template>
                                </data-table>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-success m-2" @click="onModalSaveClick" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">SAVE</button>
                <button type="button" class="btn btn-secondary m-2" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage">BACK</button>
                <button type="button" class="btn btn-primary m-2" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>
